import WizardItemSingleImage from './wizardItemSingleImage';
import WizardItemSingleIcon from './wizardItemSingleIcon';
import WizardItemDropdownList from './wizardItemDropdownList';
import WizardItemRadioButtons from './wizardItemRadioButtons';
import WizardItemSlider from './wizardItemSlider';
import WizardItemNumberedBoxes from './wizardItemNumberedBoxes';
import WizardItemNumberInput from './wizardItemNumberInput';
import WizardItemTextInputSingleLine from './wizardItemTextInputSingleLine';
import WizardItemTextInputMultiLine from './wizardItemTextInputMultiLine';
import WizardItemLocationSearch from './wizardItemLocationSearch';
import WizardItemGbPostCodeSearch from './wizardItemGbPostCodeSearch';
import WizardItemForms from './wizardItemForms';
import WizardItemCalendar from './wizardItemCalendar';
import WizardItemDeadEndMessage from './wizardItemDeadEndMessage';
import WizardItemRedirectResult from './wizardItemRedirectResult';
import WizardItemGlobalGenericEmissionsConversion from './wizardItemGlobalGenericEmissionsConversion';
import WizardItemInformationMessage from './wizardItemInformationMessage';


export const questionsMap = {
	SingleImage: WizardItemSingleImage,
	MultipleImages: WizardItemSingleImage,
	SingleIcon: WizardItemSingleIcon,
	MultipleIcons: WizardItemSingleIcon,
	DropdownList: WizardItemDropdownList,
	RadioButtons: WizardItemRadioButtons,
	Slider: WizardItemSlider,
	NumberedBoxes: WizardItemNumberedBoxes,
	NumberInputSingleOption: WizardItemNumberInput,
	NumberInputMultipleOptions: WizardItemNumberInput,
	TextInputSingleLine: WizardItemTextInputSingleLine,
	TextInputMultiLine: WizardItemTextInputMultiLine,
	Form: WizardItemForms,
	Calendar: WizardItemCalendar,
	LocationSearch: WizardItemLocationSearch,
	GbPostCodeSearch: WizardItemGbPostCodeSearch,
	DeadEndMessage: WizardItemDeadEndMessage,
	RedirectResult: WizardItemRedirectResult,
	GlobalGenericEmissionsConversion: WizardItemGlobalGenericEmissionsConversion,
	InformationMessage: WizardItemInformationMessage,
};